export type Pluralization = {
	plural: string | ((count: number) => string);
	single: string | ((count: number) => string);
	none: string | ((count: number) => string);
};
export const pluralize = (count: number, pluralization: Pluralization) => {
	let pluralizer: Pluralization[keyof Pluralization];
	switch (count) {
		case 0:
			pluralizer = pluralization.none;
			break;
		case 1:
			pluralizer = pluralization.single;
			break;
		default:
			pluralizer = pluralization.plural;
			break;
	}

	return typeof pluralizer === 'string' ? pluralizer : pluralizer(count);
};
